import { render, staticRenderFns } from "./CreateLeadAcceptFile.vue?vue&type=template&id=fd268818&"
import script from "./CreateLeadAcceptFile.vue?vue&type=script&lang=js&"
export * from "./CreateLeadAcceptFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports